<template>
  <section id="mainContent">
    <general-header :headerIcon="['time-outline']" :headerTitle="$t('Saldo de horas')"></general-header>
    <left-menu></left-menu>

    <shadow-box
      class="balance-table"
      v-if="!isLoading"
    >
      <div class="header-wrapper">
        <date-picker
          placeholder="Últimos 30 dias"
          :lang="lang" range
          @change="pageData"
          v-model="timeRange"
          :disabled-date="(date) => date >= new Date()"
          :clearable="false"
        >
          <i slot="icon-calendar">
            <ion-icon name="today-outline"></ion-icon>
          </i>
        </date-picker>
  
        <div class="balances-wrapper">
          <general-tooltip
            class="tooltip-balance"
            :content="$t('tooltip_update', { date: this.lastAtt })"
            @show-tooltip="handleTooltip"
            @click.native="forceReload"
          >
            <img 
              src="../../../../assets/img/tooltip/information-circle-outline.svg" 
              alt="dica de ferramenta"
            >
          </general-tooltip>
          <div class="total-hour-balance" :style="[{'color': totalBalance.positive ? '#2AC166' : '#FF445D'}, {'border': totalBalance.positive ? '1px solid #2AC166' : '1px solid #FF445D'}]">
            <ion-icon name="timer-outline"></ion-icon>
            <span v-if="this.canSeeHoursBalance">
              {{$t("Saldo total acumulado")}} <span><span v-if="totalBalance.positive && totalBalance.balance !== '00:00'">+</span>{{ totalBalance.balance }}</span>
            </span>
          </div>
  
          <div class="total-hour-balance" :style="[{'color': totalBalance.positive ? '#2AC166' : '#FF445D'}, {'border': totalBalance.positive ? '1px solid #2AC166' : '1px solid #FF445D'}]">
            <ion-icon name="timer-outline"></ion-icon>
            {{$t("Saldo de horas no período acumulado")}} <span><span v-if="totalBalanceByPeriod.positive && totalBalanceByPeriod.balance !== '00:00'">+</span>{{ totalBalanceByPeriod.balance }}</span>
          </div>
          
        </div>
      </div>
      
      <div class="balance-table-card">
        <div class="balance-table-header">
          <div id="first-col">{{$t("Data")}}</div>
          <div id="second-col">{{$t("Horas necessárias")}}</div>
          <div id="third-col">{{$t("Horas trabalhadas")}}</div>
          <div id="fourth-col">{{$t("Saldo")}}</div>
        </div>

        <div class="balance-table-content">
          <div class="table-content-wrapper">
            <div class="content-line" v-for="balance, index in balances" :key="index">
              <div class="date-box">
                {{balance.pointReference | formatDate}}
                <span>{{balance.pointReference | strDayFull}}</span>
              </div>
  
               <div class="needed-hours">
                {{ balance.workingDayTotal }}
              </div>
  
              <div class="worked-hours">
                {{ `${balance.workedHours}` }}
              </div>
  
              <div class="balance-hours"  :style="[{'color': balance.dayBalance === '00:00' ? '#7E8DA7' : balance.positive ? '#2AC166' : '#FF445D'}]">
                 <span v-if="balance.positive && balance.balance !== '00:00'">+</span>{{ balance.balance }}
              </div>
            </div>
          </div>
          
        </div>
      </div>

      <div class="footer-text">
        <span>{{ this.toleranceWarning }}</span>
        <div>{{$t("Pode conter fatores multiplicações nas horas extras aplicadas. Qualquer dúvida, verifique com seu gestor.")}}</div>
      </div>
    </shadow-box>

    <dot-loader v-else></dot-loader>

  </section>  
</template>

<script>
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from '../../../../utils';
import { BALANCE_HOURS, BALANCE_HOURS_FILTERED } from "../../../../urlConfig";
import generalHeader from "../../components/layouts/generalHeader.vue";
import dotLoader from "../../components/dotLoader.vue";
import leftMenu from "../../components/leftMenu.vue";
import shadowBox from "../../components/layouts/shadowBox.vue";
import generalTooltip from "../../components/generalTooltip.vue";
import DatePicker from 'vue2-datepicker';

export default {
  data() {
    return {
      isLoading: false,
      lastReload: 0,
      totalBalance: '',
      totalBalanceByPeriod: '',
      timeRange: null,
      initDate: new Date(moment().subtract(8, 'days')),
      endDate: new Date(moment().subtract(1, 'days')),
      balances: [],
      toleranceWarning: '',
      isTooltipVisible: false,
      lang: {
        formatLocale: {
          weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
          weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
          months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        },
        monthFormat: 'MMMM',
      },
    }
  },
  components: {
    generalHeader,
    dotLoader,
    leftMenu,
    shadowBox,
    generalTooltip,
    DatePicker
  },
  name: 'BalanceHours',
  methods: {
    forceReload() {
      let dataNow = new Date().getTime();
      if (dataNow > this.lastReload) {
        this.lastReload = dataNow + 60000;
        this.pageData();
      }
    },
    showTooltip() {
      this.isTooltipVisible = true;
    },
    hideTooltip() {
      this.isTooltipVisible = false;
    },
    handleTooltip(isVisible) {
      this.isTooltipVisible = isVisible;
    },
    pageData(){
      this.isLoading = true;
      this.lastAtt = moment(new Date()).format('DD/MM/YYYY HH:mm');

      if(this.timeRange) {
        this.initDate = moment(this.timeRange[0]).format("YYYY-MM-DD")
        this.endDate = moment(this.timeRange[1]).format("YYYY-MM-DD")
      }

      moment.locale('pt-br');

      let url = BALANCE_HOURS;
      url += "?init=" + moment(this.initDate).format("YYYY-MM-DD");
      url += "&end=" + moment(this.endDate).format("YYYY-MM-DD");

      UTIL_SERVICE.console("URL:", url);

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT POINT_HISTORY:", response.data);

        this.balances = response.data.balances;

        this.totalBalance = response.data.resume[0];
        this.totalBalanceByPeriod = response.data.resume[1];
        this.toleranceWarning = response.data.toleranceWarning;

        this.isLoading = false;
      }).catch((error) => {
        this.isLoading = false;
      })

    },
  },
  computed: {
    tooltipContent() {
      return this.$t(`A última atualização de dados foi feita no dia ${this.lastAtt}. Para atualizar novamente, clique aqui.`);
   }
  },
  beforeMount() {
    this.pageData();

    this.canSeeHoursBalance = UTIL_SERVICE.getStorage('userAccess').canSeeHoursBalance;
  }
}

</script>

<style lang="scss">
.balance-table {
  margin-right: 47px;
  position: relative;
  padding: 32px 16px;
  
  .header-wrapper {
    display: flex;
    gap: 10px;
    align-items: flex-end;
    justify-content: space-between;

    .mx-icon-calendar {
      cursor: pointer !important;
    }

    .balances-wrapper {
      display: flex;
      gap: 16px;
      position: relative;

      .tooltip-balance {
        cursor: pointer;
        position: absolute;
        top: 15px;
        left: -36px;
      }
  
      .total-hour-balance {
        transition: 0.5s;
        border-radius: 10px;
        border: 0.848px solid #2AC166;
        background: var(--leftMenuColor);
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.14);
        display: flex;
        padding: 5.087px 11.021px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        color: #2AC166;
        height: 50px;
      }
    }
  }

  .mx-icon-calendar {
    transition: 0.5s;
    color: var(--darkBlue);
    right: 30px;
  }

  .balance-table-card {
    width: 100%;
    margin-top: 23px;
    margin-bottom: 32px;

    .balance-table-header {
      display: flex;
      width: 100%;
      color: #939699;
      font-size: 11px;
      font-weight: 400;
      justify-content: space-between;
      margin-bottom: 1px solid var(--border);
      position: relative;

      #first-col {
        width: 77.55px;
      }

      #second-col {
        width: 98px;
      }

      #third-col {
        width: 106px;
      }

      #fourth-col {
        width: 70px;
        text-align: center;
      }
    }

    .balance-table-content {
      font-size: 14px;
      font-weight: 400;
      display: flex;
      justify-content: center;
      height: 100%;
      flex-direction: column;
      align-items: center;
      gap: 11px;

      .table-content-wrapper {
        width: 100%;

        .content-line {
          transition: 0.5s;
          width: 100%;
          border-bottom: 1px solid var(--border);
          display: flex;
          align-items: center;
          position: relative;
          justify-content: space-between;
  
          .date-box {
            display: flex;
            flex-direction: column;
            color: var(--text);
            font-size: 11px;
            padding: 8px 0px;
            width: 77.55px;
  
            .date-name {
              color:var(--text);
              font-size: 9px;
              margin: 0;
            }
          }
  
          .needed-hours {
            font-size: 13px;
            color: var(--text);
            width: 98px;
            text-align: center;
          }
  
          .worked-hours {
            color: var(--text);
            width: 106px;
            text-align: center;
          }
  
          .balance-hours {
            left: 162px;
            width: 70px;
            text-align: center;
          }
        }
  
        .content-line:last-child {
          border-bottom: none;
        }
      }

      
    }
  }
  .footer-text {
    font-size: 13px;
    text-align: center;
    color: var(--text)
  }
}

.mx-input {
  transition: 0.5s;
  border-radius: 10px !important;
  background-color: var(--leftMenuColor) !important;
  border: 1px solid var(--border);
  color: var(--darkBlue) !important;
  width: 100%;
  cursor: pointer
}

.mx-input::placeholder {
  color: var(--darkBlue)
}

.mx-datepicker-main {
  background-color: var(--leftMenuColor) !important;
  background: var(--leftMenuColor) !important;
  border: 1px solid var(--border);
}

.mx-calendar {
  border: none !important;
  color: var(--darkBlue) !important;
}

.cell .disabled {
  background-color: black;
}

</style>


// WEBPACK FOOTER //
// src/vue/views/restricted/summary/BalanceHours.vue